import React from "react";
import { FaRegPaperPlane } from "react-icons/fa";

export default function Send(props) {

  return (
    <>
      <div className="icon-button">
        <FaRegPaperPlane/>
      </div>
    </>
  );
}
